import React from 'react';

interface Props { onSkip: () => void; }

export const SkipButton: React.FC<Props> = ({ onSkip }) => (
  <button className="bs-skip" onClick={onSkip} aria-label="Skip introduction">
    Skip →
  </button>
);
